import { useQuery } from 'data-fetching-client';
import { GET_PUBLIC_CURRENCIES } from 'pricing-pages-api/currency/queries';
import { getI18nLanguage } from 'pricing-pages-ui-components/utils/languageUtils';
const CURRENCY_EARLY_REQUEST_NAME = 'currency';
export const useCurrencyData = () => {
  var _getI18nLanguage, _COUNTRY_CODE_FROM_LO;
  const browserLocale = ((_getI18nLanguage = getI18nLanguage()) === null || _getI18nLanguage === void 0 ? void 0 : _getI18nLanguage.toLowerCase()) || 'en';
  const preferredCountryCode = (_COUNTRY_CODE_FROM_LO = window.COUNTRY_CODE_FROM_LOCALE) === null || _COUNTRY_CODE_FROM_LO === void 0 ? void 0 : _COUNTRY_CODE_FROM_LO.toUpperCase();
  const {
    data,
    error,
    loading
  } = useQuery(GET_PUBLIC_CURRENCIES, {
    variables: {
      earlyRequestName: CURRENCY_EARLY_REQUEST_NAME,
      browserLocale,
      preferredCountryCode
    }
  });
  const currencyData = data === null || data === void 0 ? void 0 : data.currencies;
  return {
    currencyData,
    error,
    loading,
    displayedCurrencyCode: currencyData === null || currencyData === void 0 ? void 0 : currencyData.displayedCurrencyCode
  };
};